import { React, useContext, useState, useEffect } from "react";
import { useParams } from "react-router-dom";
import { useQuery, useMutation, gql } from '@apollo/client';
//import FirmSubUsers from './FirmSubUsers';
import ThemeContext from "../../../../context/ThemeContext";
import { InputText } from "primereact/inputtext";
import { InputNumber } from 'primereact/inputnumber';
import { Fieldset } from 'primereact/fieldset';
import { RadioButton } from "primereact/radiobutton";
import { Button } from 'primereact/button';
import { Dropdown } from 'primereact/dropdown';
import { Password } from 'primereact/password';


const GET_POST = gql`
query MyQuery($userName: String!) {
    tbl_user_detail(where: { user_name: { _eq: $userName } }) {
        user_name
        name
        last_name
        user_type
        firm_main_code
        firm_sub_code
        dpr_main_code
        dpr_sub_code
        user_lang
        data_lang
        mail_address
        acs_id
        

    }
    tbl_login(where: { user_name: {_eq: $userName}}) {
        user_name
        pass
        active
       
      }
  }
 
`; 

const GET_MDPR = gql`
query MyQuery($firmSubCode: String!) {
    tbl_dpr_main(where: { firm_sub_code: { _eq: $firmSubCode} }) {
        firm_main_code
        firm_sub_code
        lang
        dpr_main_code
        dpr_main_name
      
    }
   
  }
 
`; 
const GET_SDPR = gql`
query GetSdprData($firmSubCode: String!, $dprMainCode: String!) {
    tbl_dpr_sub(where: { firm_sub_code: { _eq: $firmSubCode }, dpr_main_code: { _eq: $dprMainCode } }) {
        firm_main_code
        firm_sub_code
        lang
        dpr_main_code
        dpr_sub_code
        dpr_sub_name
      
    }
   
  }
 
`; 

const UPDATE_FIRM = gql`
  mutation UpdateFirm(
    $userName: String!
    $name: String!
    $lastName: String!
    $userType: String!
    $dprMainCode: String!
    $dprSubCode: String!
    $userLang: String!
    $dataLang: String!
    $mailAddress: String
    $accLevel: Int

  ) {
    update_tbl_user_detail(
      where: { user_name: { _eq: $userName } },
      _set: { user_name: $userName, name: $name, last_name: $lastName, 
        user_type: $userType, dpr_main_code: $dprMainCode, dpr_sub_code: $dprSubCode,
        user_lang: $userLang, data_lang: $dataLang, acs_id:$accLevel, mail_address: $mailAddress}
    ) {
      affected_rows
    }
  }
`;

const UPDATE_LOGIN = gql`
  mutation UpdateLogin(
    $userName: String!
    $pass: String!
    $active: Boolean!
    

  ) {
    update_tbl_login(
      where: { user_name: { _eq: $userName } },
      _set: { user_name: $userName, pass: $pass, active: $active}
    ) {
      affected_rows
    }
  }
`;


const INSERT_PROFILE = gql`
  mutation InsertProfile(
    $firmMainCode: String
    $firmSubCode: String
    $userName: String
    $name: String
    $lastName: String
    $userType: String
    $dprMainCode: String
    $dprSubCode: String
    $userLang: String
    $dataLang: String
    $mailAddress: String
    $accLevel: Int

  ) {
    insert_tbl_user_detail(
      objects: {
        firm_main_code: $firmMainCode,
        firm_sub_code: $firmSubCode,
        user_name: $userName,
        name: $name,
        last_name: $lastName, 
        user_type: $userType, 
        dpr_main_code: $dprMainCode, 
        dpr_sub_code: $dprSubCode,
        user_lang: $userLang,
        data_lang: $dataLang,
        acs_id:$accLevel,
        mail_address: $mailAddress
      }
    ) {
      affected_rows
    }
  }
`;

const INSERT_LOGIN = gql`
  mutation InsertProfile(
    $userName: String!
    $pass: String!
    $active: Boolean!

  ) {
    insert_tbl_login(
      objects: {
        user_name: $userName, 
        pass: $pass, 
        active: $active
      }
    ) {
      affected_rows
    }
  }
`;



const UserDtlEdit = () => {


const {theme, setTheme} = useContext(ThemeContext);



  const { user_name } = theme;
  const { varCode, setVarCode } = useContext(ThemeContext);
  console.log(theme);
  const { loading, error, data, refetch } = useQuery(GET_POST, {
    variables: { userName: varCode },
  });
  const [updateFirm] = useMutation(UPDATE_FIRM);
  const [UpdateLogin] = useMutation(UPDATE_LOGIN);
  const [InsertProfile] = useMutation(INSERT_PROFILE);
  const [InsertProfile2] = useMutation(INSERT_LOGIN);

  const firmData = data && data.tbl_user_detail ? data.tbl_user_detail[0] : null;
  
  const [userName, setUserName] = useState(firmData ? firmData.user_name : "");
  const [name, setName] = useState(firmData ? firmData.name : "");
  const [lastName, setLastName] = useState(firmData ? firmData.last_name : "");
  const [userType, setUserType] = useState(firmData ? firmData.user_type : "CRM");
  const [dprMainCode, setDprMainCode] = useState (firmData ? firmData.dpr_main_code: "USR");
  const [accLevel, setAccLevel] = useState(firmData ? firmData.acs_id.toString() : "3");
  const [dprSubCode, setDprSubCode] = useState (firmData ? firmData.dpr_sub_code: "USR");
  const [userLang, setUserLang] = useState (firmData? firmData.user_lang: "en");
  const [dataLang, setDataLang] = useState (firmData? firmData.data_lang:"en");
  const [mailAddress, setMailAddress] = useState (firmData? firmData.mail_address:"");
  const [firmSubCode, setFirmSubCode] = useState (firmData? firmData.firm_sub_code:"");

  const loginData = data && data.tbl_login ? data.tbl_login[0] : null;

  const tblLoginData = data && data.tbl_login ? data.tbl_login[0] : null;
  


  const [pass, setPass] = useState(tblLoginData ? tblLoginData.pass : "");
  const [active, setActive] = useState(tblLoginData ? tblLoginData.active : false);


  


  //const mdprData = useQuery(GET_MDPR, { variables: { firmSubCode: firmData?.data?.tbl_user_detail[0]?.firm_sub_code || "" } });
  
  const [firmName, setFirmName] = useState("");
  
  const [firmType, setFirmType] = useState("");  
  const [place, setPlace] = useState( "");
  console.log("Firm Data:", firmData);
  const { loading: mdprLoading, error: mdprError, data: mdprData } = useQuery(GET_MDPR, {
    variables: { firmSubCode: firmData ? firmData.firm_sub_code : "" },
  });
  console.log("dpr:", mdprData);

  const { loading: msprLoading, error: msprError, data: sdprData } = useQuery(GET_SDPR, {
    variables: { firmSubCode: firmData ? firmData.firm_sub_code : "", dprMainCode: dprMainCode},
  });
  console.log("dpr:", sdprData);
 


  const userLangSelectItems = [
    {label: 'English', value: 'en'},
    {label: 'Turkish', value: 'tr'},
    {label: 'Russian', value: 'ru'},
    {label: 'German', value: 'de'},
    {label: 'Spanish', value: 'es'},
    {label: 'Dutch', value: 'nl'},
    {label: 'Italian', value: 'it'},
    
    
    
  ];









  useEffect(() => {
    if (firmData) {
        setUserName(firmData.user_name);
        setName(firmData.name);
        setLastName(firmData.last_name);
        setUserType(firmData.user_type);
        setDprMainCode(firmData.dpr_main_code);
        setDprSubCode(firmData.dpr_sub_code);
        setUserLang(firmData.user_lang);
        setDataLang(firmData.data_lang);
        setMailAddress(firmData.mail_address);
        setAccLevel(firmData.acs_id.toString());
       
       

        if (data.tbl_login) {
            setPass(tblLoginData.pass);
            setActive(tblLoginData.active);
            console.log("pas:", tblLoginData)
           
        }
    }
  }, [firmData]);

  

  const handleUpdate = () => {
    updateFirm({
      variables: {
        userName: userName,
        name: name,
        lastName: lastName,
        userType: userType,
        dprMainCode: dprMainCode,
        dprSubCode: dprSubCode,
        userLang: userLang,
        dataLang: dataLang,
        mailAddress: mailAddress,
        accLevel: accLevel
      },
    })
      .then(() => {
        window.alert("User Detail updated successfully!");
        handleUpdateLogin();
       
      })
      .catch((error) => {
        console.error("Error updating user detail:", error);
      });
  };

  const handleUpdateLogin = () => {
    UpdateLogin({
      variables: {
        userName: userName,
        pass: pass,
        active: active,
        
      },
    })
      .then(() => {
        window.alert("Login User updated successfully!");
        refetch();
       
      })
      .catch((error) => {
        console.error("Error updating login user:", error);
      });
  };

  const handleInsert = () => {
    InsertProfile({
        variables: {
            firmSubCode: "000",
            firmMainCode: "000",
            userName: userName,
            name: name,
            lastName: lastName,
            userType: userType,
            dprMainCode: dprMainCode,
            dprSubCode: dprSubCode,
            userLang: userLang,
            dataLang: dataLang,
            mailAddress: mailAddress,
            accLevel: accLevel,
            
        },
    })
    .then(() => {
        window.alert("Firm insert successfully!");
    })
    .catch((error) => {
        console.error("Error inserting firm:", error);
        
        // Detaylı hata mesajlarını konsola yazdır
        console.error("GraphQL Errors:", error.graphQLErrors);
        console.error("Network Error:", error.networkError);
        console.error("Message:", error.message);
        
        const pkError = error.graphQLErrors.some(err => 
            err.message.includes("duplicate key value") || err.extensions.code === "23505" // PostgreSQL unique violation code
        );

        if (pkError) {
            setErrorType("PK_ERROR");
        } else {
            setErrorType("GENERAL_ERROR");
        }
        window.alert("This Record Already!"); // Hata durumunda dialogu aç
    });
};

const handleInsert2= () => {
    InsertProfile2({
        variables: {
            userName: userName,
            pass: pass,
            active: active,
            
        },
    })
    .then(() => {
        handleInsert();
        window.alert("Firm insert successfully!");

    })
    .catch((error) => {
        console.error("Error inserting firm:", error);
        
        // Detaylı hata mesajlarını konsola yazdır
        console.error("GraphQL Errors:", error.graphQLErrors);
        console.error("Network Error:", error.networkError);
        console.error("Message:", error.message);
        
        const pkError = error.graphQLErrors.some(err => 
            err.message.includes("duplicate key value") || err.extensions.code === "23505" // PostgreSQL unique violation code
        );

        if (pkError) {
            setErrorType("PK_ERROR");
        } else {
            setErrorType("GENERAL_ERROR");
        }
        window.alert("This Record Already!"); // Hata durumunda dialogu aç
    });
};

  const [errorType, setErrorType] = useState("");


  const userSdprSelectItems = [
    {label: 'Developer', value: "SUP"},
    {label: 'Admin', value: "MNG"},
    {label: 'User', value: "USR"}
  
    
    
  ];

  const userMdprSelectItems = [
    {label: 'Develeloper', value: "1"},
    {label: 'Admin', value: "2"},
    {label: 'User', value: "3"}
  
    
    
    
  ];
 

  if (loading) return <p>Loading...</p>;
  if (error) return <p>Error: {error.message}</p>;
  

  

  
  

  return (
    <div className="container p-2 mx-auto sm:p-4 dark:text-gray-100">
      <h2 className="mb-4 text-2xl font-semibold leading-tight">User Details</h2>

      <div className="card pt-1 -ml-10 -my-10 font-thin"> 
            <Fieldset>
            <p className="my-0 font-thin ">

          <div className="flex gap-4 -mb-5">
          <div className="w-1/4 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-semibold text-gray-950 justify-content-center gap-4"
     htmlFor="username">User Name</label>
    <InputText className="w-full font-semibold" 
    id="username" value={userName}
    onChange={(e) => setUserName(e.target.value)}
    />
  </div>

  <div className="w-1/4 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full " className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">Password</label>
    <Password className="w-full font-semibold" 
    id="firmname" value={pass} 
    onChange={(e) => setPass(e.target.value)} />
  </div>
  <div className="card  flex-col font-medium  flex justify-content-center">
  
  <label htmlFor="firmtype" 
  className=" flex-col -my-8 ml-0 mb-5 align-items-center block font-medium text-gray-950">Active </label><p></p>
  <div className="flex ml-0 flex-wrap gap-6">
  <div className="flex ml-0 align-items-center">
  <RadioButton inputId="ingredient1" name="active" value={true}  onChange={(e) => setActive(e.value)} checked={active === true} />
          <label htmlFor="ingredient1" className="ml-2">Active</label>
          
      </div>
      <div className="flex align-items-center">
          <RadioButton inputId="ingredient2" name="inactive" value={false}  onChange={(e) => setActive(e.value)} checked={active === false} />
          <label htmlFor="ingredient2" className="ml-2">Inactive</label>
      </div>
      </div>
      </div>
  </div>
  <div className="flex gap-4">
          <div className="w-1/2 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">Name</label>
    <InputText className="w-full font-semibold" 
    id="username" value={name}
    onChange={(e) => setName(e.target.value)} />
  </div>

  <div className="w-1/2 p-inputtext-sm flex-column gap-3">
    <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">Last Name</label>
    <InputText className="w-full font-semibold" 
    id="firmname" value={lastName} 
    onChange={(e) => setLastName(e.target.value)} />
    
  </div>
  
  </div>

  <div className="flex gap-4 mt-5 mb-5">
          <div className="w-1/5 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="username">User Type</label>
    <InputText className="w-full" 
    id="username" value={userType}
    onChange={(e) => setUserType(e.target.value)} />
  </div>
  <div className="w-2/5 p-inputtext-sm  flex-column gap-3">
  <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">User Language</label>  
  <Dropdown className="w-full"
  value={userLang} 
  options={userLangSelectItems} 
  onChange={(e) => setUserLang(e.value)}
   placeholder="Select a Language"/>
  </div>
  
  <div className="w-2/5 p-inputtext-sm  flex-column gap-3">
  <label styleClass="w-full" className="block font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">Data Language</label>  
  <Dropdown  className="w-full"
  value={dataLang} 
  options={userLangSelectItems} 
  onChange={(e) => setDataLang(e.value)}
   placeholder="Select a Language"/>
  </div>
   </div>
   
   <div className="flex gap-4">
   <div className="w-1/4 p-inputtext-sm  flex-column gap-3">
    <label className="block  p-inputtext-sm font-semibold text-gray-950 justify-content-center gap-4"
     htmlFor="username">Accsess Id</label>
    <InputText className="w-full font-semibold" 
    id="username" value={accLevel}
    onChange={(e) => setAccLevel(e.target.value)}
    />
  </div>
       <div className="w-1/2 p-inputtext-sm  flex-column gap-3">
  <label styleClass="w-full" className="block  font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">Access Level</label>  
  <Dropdown className="w-full"
  value={accLevel} 
  options={userMdprSelectItems} 
  onChange={(e) => setAccLevel(e.value)}
   placeholder="Select a Language"/>
  </div>

  
  <div className="w-1/2 p-inputtext-sm  flex-column gap-3">
  <label styleClass="w-full" className="block font-medium text-gray-950 justify-content-center gap-4"
     htmlFor="firmname">Title</label>  
  <Dropdown  className="w-full"
  value={dprSubCode} 
  options={userSdprSelectItems} 
  onChange={(e) => setDprSubCode(e.value)}
   placeholder="Select a Language"/>
  </div>
  
  </div>
 </p>
            </Fieldset>
        </div>
        <div className="flex gap-4">
        <div className="mt-0 ">
        <Button label="New" aria-label="New" 
          className=" p-button-sm p-button-outlined bg-purple-800 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded-md"
          onClick={handleInsert2}  />
          
          </div>

       
          <div className="mt-0 ">
        <Button label="Update" aria-label="Update" 
          className=" p-button-sm p-button-outlined bg-purple-800 hover:bg-blue-600 text-white font-semibold px-4 py-2 rounded-md"
          onClick={handleUpdate}  />
          
          </div>
          </div>
</div>
);
};

export default UserDtlEdit;
